import createSvgIcon from '../Utils/CreateSvgIcon';

//THIS IS A TEMP ICON THAT CAN BE USED ON WHITE BACKGROUNDS - DESIGN TEAM TO PROVIDE FINAL ICON
export const LayoutGrid = createSvgIcon(
  <svg fill="none">
    <path
      d="M6.66667 2H2V6.66667H6.66667V2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0026 2H9.33594V6.66667H14.0026V2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0026 9.3335H9.33594V14.0002H14.0026V9.3335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 9.3335H2V14.0002H6.66667V9.3335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'Gallery',
  '0 0 16 16',
);
